export var ChangeEntityTypeEnum;
(function (ChangeEntityTypeEnum) {
    ChangeEntityTypeEnum["FEED"] = "Feed";
    ChangeEntityTypeEnum["MESSAGE_TEMPLATE"] = "MessageTemplate";
    ChangeEntityTypeEnum["LAYOUT"] = "Layout";
    ChangeEntityTypeEnum["DEFAULT_LAYOUT"] = "DefaultLayout";
    ChangeEntityTypeEnum["NOTIFICATION_TEMPLATE"] = "NotificationTemplate";
    ChangeEntityTypeEnum["NOTIFICATION_GROUP"] = "NotificationGroup";
    ChangeEntityTypeEnum["TRANSLATION_GROUP"] = "TranslationGroup";
    ChangeEntityTypeEnum["TRANSLATION"] = "Translation";
})(ChangeEntityTypeEnum || (ChangeEntityTypeEnum = {}));
